import Image from 'components/image'
import {
  facebookUrl,
  faqPath,
  instagramUrl,
  mobileAppDownloadPath,
  tiktokUrl,
  youtubeUrl,
} from 'lib/urls'
import { LandingPageSections } from '../LandingPage.types'
import {
  FacebookIcon,
  InstagramIcon,
  TikTokIcon,
  YouTubeIcon,
} from '../LandingPage.icons'

const showroomSections: LandingPageSections[] = [
  {
    type: 'hero',
    id: '1',
    desktopWidth: 'full',
    images: {
      desktop:
        'https://images.babylist.com/image/upload/f_auto,q_auto/v1694621290/Dynamic%20Landing%20Pages/showroom_hero_v3_desktop.jpg',
      mobile:
        'https://images.babylist.com/image/upload/f_auto,q_auto/v1694621290/Dynamic%20Landing%20Pages/showroom_hero_v3_desktop.jpg',
    },
    orientation: 'stacked',
  },
  {
    type: 'text',
    id: '2',
    desktopWidth: 'full',
    heading: 'Babylist Beverly Hills',
    isSectionPageHeader: true,
    subHeading: 'Showroom & Shop',
    background: 'none',
    includeVerticalSectionSpacing: true,
  },
  {
    type: 'divider',
    id: '3',
    variant: 'squiggle',
  },
  {
    type: 'cards',
    id: '4',
    desktopWidth: 'limited',
    imageShape: 'largeRectangle',
    background: 'white',
    mobileVariant: 'stacked',
    desktopVariant: 'twoColumns',
    cards: [
      {
        type: 'card',
        id: '8',
        headerText: 'Location',
        subHeaderContent:
          '211 SOUTH BEVERLY DRIVE<br />BEVERLY HILLS, CA 90212',
      },
      {
        type: 'card',
        id: '10',
        headerText: 'Hours',
        subHeaderContent: 'MONDAY — SUNDAY<br /> 11AM — 7PM',
      },
    ],
  },
  {
    type: 'feature_highlight',
    id: '5',
    imageUrl:
      'https://images.babylist.com/image/upload/f_auto,q_auto/v1695413517/Dynamic%20Landing%20Pages/arrived_to_la_v3.png',
    headerText: 'Babylist Beverly Hills is Open!',
    description: {
      content: [
        'At Babylist, we know that getting the right stuff for your growing family is a <b><em>big deal</em></b>, so we&rsquo;ve brought our registry experience to life with our first <b><em>big showroom</em></b> in the heart of Beverly Hills. We want to celebrate the moment with you, so bring friends and family, or pop in on your own and let our team take care of you.',
        'Test drive the best selection of strollers, find your perfect nursery aesthetic, and get hands on with all the baby gear you need. While you&rsquo;re at it, why not try out our adult-sized baby bouncer or play our nostalgic claw game?',
        'Stop by and say hi!',
      ],
      renderAsListItems: false,
    },
    desktopWidth: 'full',
    layout: 'stacked',
    imagePlacement: 'left',
    background: 'mutedEggplant',
  },
  {
    type: 'cards',
    id: '6',
    desktopWidth: 'limited',
    imageShape: 'largeRectangle',
    background: 'white',
    mobileVariant: 'stacked',
    desktopVariant: 'twoColumns',
    headerText: `What to Expect When You're at the Showroom`,
    cards: [
      {
        type: 'card',
        id: '1',
        headerText: 'Babylist-Curated Picks',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1695413515/Dynamic%20Landing%20Pages/babylist_curated_picks_v3.png',
        subHeaderContent: `Get hands on with our most registered-for and expert-chosen products. The showroom was designed for you to see how products will fit into your home — stroll through demo nurseries, bathrooms, play areas, and a travel zone with a stroller track and life-sized car.
          <br /><br /><b>Need an expert?</b>
          <br />We have a trained staff that&rsquo;s ready to answer all your questions. Or make an appointment with a registry consultant!`,
        link: {
          type: 'link',
          id: '1',
          text: 'Book Now',
          url: 'https://app.acuityscheduling.com/schedule.php?owner=29600042',
        },
      },
      {
        type: 'card',
        id: '2',
        headerText: 'Register IRL',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1695413515/Dynamic%20Landing%20Pages/registered_irl_v3.png',
        subHeaderContent: `Let&rsquo;s get your registry built. Make an appointment with a registry consultant or pop in — our trained staff is ready to answer your questions and point you toward our signature Babylist Guides which are linked with convenient QR codes throughout the showroom. Download the app ahead of time to make it even easier!`,
        link: {
          type: 'link',
          id: '1',
          text: 'Download the app',
          url: mobileAppDownloadPath(),
        },
      },
      {
        type: 'card',
        id: '3',
        headerText: 'Let&rsquo;s Get Social',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1695413515/Dynamic%20Landing%20Pages/lets_get_social_v3.png',
        subHeaderContent: `Come play with us! Our mission is to make this a joyful experience from start to finish, which means photo moments, interactive games, and more. There are areas for the young and the young at heart…and you never know where a fun surprise (or prize) awaits!`,
      },
      {
        type: 'card',
        id: '4',
        headerText: 'The Shop',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1695413516/Dynamic%20Landing%20Pages/the_shop_v3.png',
        subHeaderContent: `Looking for the perfect baby shower gift or a little something for the new parent or baby in your life? The Babylist Shop has a curated assortment of giftable items you&rsquo;ll love giving and they&rsquo;ll love getting.`,
      },
    ],
  },
  {
    type: 'divider',
    id: '7',
    variant: 'squiggle',
  },
  {
    type: 'spacer',
    id: '8',
  },
  {
    type: 'cards',
    id: '9',
    desktopWidth: 'full',
    imageShape: 'largeRectangle',
    background: 'cream',
    mobileVariant: 'stacked',
    desktopVariant: 'threeColumns',
    headerText: `More Ways to Visit`,
    cards: [
      {
        type: 'card',
        id: '1',
        headerText: 'Interested in a Private Tour or Event?',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1697750059/Dynamic%20Landing%20Pages/Showroom/Private_Tour.png',
        subHeaderContent: `We can't wait to hear from you!
          <br />Email press@babylist.com`,
        link: {
          type: 'link',
          id: '1',
          text: 'Contact Us',
          url: 'mailto:press@babylist.com',
        },
      },
      {
        type: 'card',
        id: '2',
        headerText: 'Stay Connected',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1697750059/Dynamic%20Landing%20Pages/Showroom/Stay_Connected.png',
        subHeaderContent: `Follow Babylist on social to see what we're up to at the Babylist Showroom, stay up to date on upcoming events, learn about new products when they arrive, and so much more. We'd love to see you share your experience and tag @Babylist on socials.`,
        socialLinks: [
          {
            type: 'image_link',
            id: '1',
            imageComponent: <InstagramIcon />,
            url: instagramUrl,
          },
          {
            type: 'image_link',
            id: '2',
            imageComponent: <TikTokIcon />,
            url: tiktokUrl,
          },
          {
            type: 'image_link',
            id: '3',
            imageComponent: <FacebookIcon />,
            url: facebookUrl,
          },
          {
            type: 'image_link',
            id: '4',
            imageComponent: <YouTubeIcon />,
            url: youtubeUrl,
          },
        ],
      },
      {
        type: 'card',
        id: '3',
        headerText: 'Visit Us Virtually',
        imageUrl:
          'https://images.babylist.com/image/upload/f_auto,q_auto/v1697750059/Dynamic%20Landing%20Pages/Showroom/Visit_Us.png',
        subHeaderContent: `Can&rsquo;t make it to LA? You can still explore the showroom and discover the best products, gifts and more for you or the new baby in your life.`,
        link: {
          type: 'link',
          id: '1',
          text: 'See Our Experience',
          url: 'https://showroom.babylist.com/babylist-flagship/',
        },
      },
    ],
  },
  {
    type: 'cards',
    id: '10',
    desktopWidth: 'full',
    imageShape: 'smallSquare',
    background: 'white',
    mobileVariant: 'stacked',
    desktopVariant: 'twoColumns',
    headerText: `Visiting Los Angeles`,
    cards: [
      {
        type: 'card',
        id: '1',
        headerText: 'Travel',
        imageUrl:
          'https://images.babylist.com/image/upload/v1689028222/Dynamic%20Landing%20Pages/Showroom_card_smallTriangle.svg',
        subHeaderContent: `The closest airports to the Showroom are:
          <br /><br /><a href="https://www.flylax.com/" target="_blank">Los Angeles International Airport</a>
          <br />1 World Way, Los Angeles
          <br /><br /><a href="https://www.hollywoodburbankairport.com/" target="_blank">Hollywood Burbank Airport</a>
          <br />2627 N Hollywood Way
          <br />Burbank`,
      },
      {
        type: 'card',
        id: '2',
        headerText: 'Where to Stay',
        imageUrl:
          'https://images.babylist.com/image/upload/v1689028222/Dynamic%20Landing%20Pages/Showroom_card_smallClover.svg',
        subHeaderContent: `Nearby hotels include:
          <br /><br /><a href="https://www.sixtyhotels.com/destinations/california/sixty-beverly-hills" target="_blank">SIXTY Beverly Hills</a>
          <br />9360 Wilshire Blvd, Beverly Hills
          <br /><br /><a href="https://www.mosaichotel.com/" target="_blank">Mosaic Hotel</a>
          <br />125 S Spalding Dr, Beverly Hills`,
      },
    ],
  },
  {
    type: 'text',
    id: '11',
    desktopWidth: 'full',
    heading: 'Still Have Questions?',
    body: `Wondering where to park, if you need a reservation, or have other questions?
      <br /><br /><a href="${faqPath}">View FAQs</a> or call us at (213) 647-3641`,
    background: 'none',
    includeVerticalSectionSpacing: true,
  },
  {
    type: 'divider',
    id: '12',
    variant: 'squiggle',
  },
  {
    type: 'brand_icon_list',
    id: '13',
    desktopWidth: 'full',
    headerText: 'Our Partners',
    callToAction: {
      type: 'link',
      id: '1',
      text: 'Interested in partnering?',
      url: 'mailto:partners@babylist.com',
    },
    icons: [
      {
        type: 'image_link',
        id: '1',
        imageComponent: (
          <Image
            alt="Babybjorn"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/BabyBjorn.png"
            width={193}
          />
        ),
        url: 'https://www.babylist.com/store/b/babybjorn/62',
      },
      {
        type: 'image_link',
        id: '2',
        imageComponent: (
          <Image
            alt="BabyJogger"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/BabyJogger.png"
            width={177}
          />
        ),
        url: 'https://www.babylist.com/store/b/baby-jogger/3',
      },
      {
        type: 'image_link',
        id: '3',
        imageComponent: (
          <Image
            alt="Babyletto"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Babyletto.png"
            width={244}
          />
        ),
        url: 'https://www.babylist.com/store/b/babyletto/223',
      },
      {
        type: 'image_link',
        id: '4',
        imageComponent: (
          <Image
            alt="ByHeart"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1691531449/Dynamic%20Landing%20Pages/ShowroomBrandPartners/ByHeart.ai"
            width={165}
          />
        ),
        url: 'https://byheart.com/',
      },
      {
        type: 'image_link',
        id: '5',
        imageComponent: (
          <Image
            alt="Chicco"
            height={61}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Chicco.png"
            width={111}
          />
        ),
        url: 'https://www.babylist.com/store/b/chicco/1',
      },
      {
        type: 'image_link',
        id: '6',
        imageComponent: (
          <Image
            alt="Maxi Cosi"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/MaxiCosi.png"
            width={162}
          />
        ),
        url: 'https://www.babylist.com/store/b/maxi-cosi/481',
      },
      {
        type: 'image_link',
        id: '7',
        imageComponent: (
          <Image
            alt="Safety 1st"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Safety1st.png"
            width={132}
          />
        ),
        url: 'https://www.babylist.com/store/search?search_term=Safety%201st',
      },
      {
        type: 'image_link',
        id: '8',
        imageComponent: (
          <Image
            alt="Tiny Love"
            height={57}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/TinyLove.png"
            width={108}
          />
        ),
        url: 'https://www.babylist.com/store/b/tiny-love/180',
      },
      {
        type: 'image_link',
        id: '9',
        imageComponent: (
          <Image
            alt="Jujube"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Jujube.png"
            width={113}
          />
        ),
        url: 'https://www.babylist.com/store/b/ju-ju-be/230',
      },
      {
        type: 'image_link',
        id: '10',
        imageComponent: (
          <Image
            alt="Nanit"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Nanit.png"
            width={115}
          />
        ),
        url: 'https://www.babylist.com/store/b/nanit/936',
      },
      {
        type: 'image_link',
        id: '11',
        imageComponent: (
          <Image
            alt="Ergobaby"
            height={60}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Ergobaby.png"
            width={187}
          />
        ),
        url: 'https://www.babylist.com/store/b/ergobaby/67',
      },
      {
        type: 'image_link',
        id: '12',
        imageComponent: (
          <Image
            alt="KylieBaby"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/KylieBaby.png"
            width={142}
          />
        ),
        url: 'https://kyliecosmetics.com/collections/kylie-baby',
      },
      {
        type: 'image_link',
        id: '13',
        imageComponent: (
          <Image
            alt="Nuna"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Nuna.png"
            width={256}
          />
        ),
        url: 'https://www.babylist.com/store/b/nuna/628',
      },
      {
        type: 'image_link',
        id: '14',
        imageComponent: (
          <Image
            alt="Tula"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Tula.png"
            width={123}
          />
        ),
        url: 'https://babytula.com/',
      },
      {
        type: 'image_link',
        id: '15',
        imageComponent: (
          <Image
            alt="Baby Brezza"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/BabyBrezza.png"
            width={210}
          />
        ),
        url: 'https://www.babylist.com/store/b/baby-brezza/680',
      },
      {
        type: 'image_link',
        id: '16',
        imageComponent: (
          <Image
            alt="Canopy"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Canopy.png"
            width={139}
          />
        ),
        url: 'https://www.babylist.com/gp/canopy-humidifier-starter-set/25215/1164629',
      },
      {
        type: 'image_link',
        id: '17',
        imageComponent: (
          <Image
            alt="Coterie"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1691531449/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Coterie.ai"
            width={140}
          />
        ),
        url: 'https://www.babylist.com/store/search?search_term=Coterie',
      },
      {
        type: 'image_link',
        id: '18',
        imageComponent: (
          <Image
            alt="Dr Browns"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/DrBrowns.png"
            width={138}
          />
        ),
        url: 'https://www.babylist.com/store/b/dr-browns/344',
      },
      {
        type: 'image_link',
        id: '19',
        imageComponent: (
          <Image
            alt="Frida"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Frida.png"
            width={107.5}
          />
        ),
        url: 'https://www.babylist.com/store/b/fridababy/465',
      },
      {
        type: 'image_link',
        id: '20',
        imageComponent: (
          <Image
            alt="Baby GAP"
            height={88}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/BabyGap.png"
            width={106}
          />
        ),
        url: 'https://www.gap.com/browse/category.do?cid=3010841&bc=true',
      },
      {
        type: 'image_link',
        id: '21',
        imageComponent: (
          <Image
            alt="Hanna Andersson"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1691531449/Dynamic%20Landing%20Pages/ShowroomBrandPartners/HannaAndersson.png"
            width={254}
          />
        ),
        url: 'https://www.hannaandersson.com/',
      },
      {
        type: 'image_link',
        id: '22',
        imageComponent: (
          <Image
            alt="Honest"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Honest.png"
            width={256}
          />
        ),
        url: 'https://www.babylist.com/store/search?search_term=The%20Honest%20Company',
      },
      {
        type: 'image_link',
        id: '23',
        imageComponent: (
          <Image
            alt="KiwiCo"
            height={88}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1691531448/Dynamic%20Landing%20Pages/ShowroomBrandPartners/KiwiCo.png"
            width={154}
          />
        ),
        url: 'https://www.kiwico.com/',
      },
      {
        type: 'image_link',
        id: '24',
        imageComponent: (
          <Image
            alt="Masimo Stork"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/MasimoStork.png"
            width={241}
          />
        ),
        url: 'https://www.masimostork.com/en-us/',
      },
      {
        type: 'image_link',
        id: '25',
        imageComponent: (
          <Image
            alt="Motorola Nursery"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/MotorolaNursery.png"
            width={332.5}
          />
        ),
        url: 'https://www.babylist.com/store/b/motorola/345',
      },
      {
        type: 'image_link',
        id: '26',
        imageComponent: (
          <Image
            alt="Mustela"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Mustela.png"
            width={133}
          />
        ),
        url: 'https://www.amazon.com/stores/node/21354637011?ref_=dp_csx_lgbl_n_luxury-beauty',
      },
      {
        type: 'image_link',
        id: '27',
        imageComponent: (
          <Image
            alt="OurPlace"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/OurPlace.png"
            width={155}
          />
        ),
        url: 'https://fromourplace.com/',
      },
      {
        type: 'image_link',
        id: '28',
        imageComponent: (
          <Image
            alt="Stokke"
            height={88}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Stokke.png"
            width={111}
          />
        ),
        url: 'https://www.babylist.com/store/b/stokke/4',
      },
      {
        type: 'image_link',
        id: '29',
        imageComponent: (
          <Image
            alt="Thinx"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Thinx.png"
            width={147}
          />
        ),
        url: 'https://www.thinx.com/',
      },
      {
        type: 'image_link',
        id: '30',
        imageComponent: (
          <Image
            alt="Wayfair"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Wayfair.png"
            width={184}
          />
        ),
        url: 'https://www.wayfair.com/baby-kids/cat/baby-kids-c45226.html',
      },
      {
        type: 'image_link',
        id: '31',
        imageComponent: (
          <Image
            alt="Wonderfold"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Wonderfold.png"
            width={256}
          />
        ),
        url: 'https://www.babylist.com/store/search?search_term=WonderFold%20Wagon',
      },
      {
        type: 'image_link',
        id: '32',
        imageComponent: (
          <Image
            alt="Being Frenshe"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/BeingFrenshe.png"
            width={162}
          />
        ),
        url: 'https://www.target.com/b/being-frenshe/-/N-q643leyonhf',
      },
      {
        type: 'image_link',
        id: '33',
        imageComponent: (
          <Image
            alt="Etsy"
            height={40}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Etsy.png"
            width={88}
          />
        ),
        url: 'https://www.etsy.com/',
      },
      {
        type: 'image_link',
        id: '34',
        imageComponent: (
          <Image
            alt="Kiki Milk"
            height={88}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1689193586/Dynamic%20Landing%20Pages/ShowroomBrandPartners/KikiMilk.png"
            width={145}
          />
        ),
        url: 'https://www.kikimilk.com/',
      },
      {
        type: 'image_link',
        id: '34',
        imageComponent: (
          <Image
            alt="Emulait"
            height={30}
            src="https://images.babylist.com/image/upload/f_auto,q_auto/v1697646752/Dynamic%20Landing%20Pages/ShowroomBrandPartners/Emulait_Logo.png"
            width={150}
          />
        ),
        url: 'https://www.emulait.com/',
      },
    ],
  },
]

export default showroomSections
